import api from '@/api'
import Vue from "vue";
import router from "@/routes";

function getTokenPayload(token) {
  try {
    if (typeof token === 'string') {
      let data = token.split('.');
      if (data.length === 3) {
        return JSON.parse(atob(data[1]));
      }
    }
    return null;
  }
  catch(err) {
    return null
  }
}

const state = {
  token: "",
  token_expires: -1,
  logged_in: false,
  is_admin: false,
  user_id: "",
  registrar_id: "",
  token_set: 0, // issued at timestamp
};

// this is a close copy of the "authenticate" mutation.
// it has to be invoked in here to set the token data right away, otherwise
// we would get invalid data upon page reload due to delay between getting
// the token and calling the "authenticate" mutation.
// this also handles the epp services and extensions that would be otherwise set
// only with successful authentication.
function authInit() {
  // check if we have what we want
  let data = localStorage.getItem('epp_token');
  if (typeof data !== 'string' || data === "") { return }

  // parse the token
  let payload = getTokenPayload(data);
  if (payload === null || !(typeof payload === 'object')) { return }

  // delete and ignore the token if it has expired
  let now = Date.now() / 1000;
  if (now > payload.exp) {
    localStorage.removeItem('epp_token');
    return;
  }

  // ignore the token if it should not be used yet
  let nbf = payload.nbf || 0;
  if (nbf > 0 && now < nbf) {
    return;
  }

  // set the token data
  state.token = data;
  state.is_admin = ('roles' in payload && payload.roles.indexOf('admin') >= 0);
  state.logged_in = payload.user_id !== "";
  state.token_expires = payload.exp;
  state.user_id = payload.user_id || "";
  state.registrar_id = payload.registrar_id || "";
  state.token_set = payload.iat;

  // give the token to the api for the next api call
  api.setSession(data);
}

// call the handler right away
authInit();

const getters = {

  isAuthed(state) {
    return state.logged_in
  },

  isAdmin(state) {
    return state.is_admin;
  },

  isSessionActive(state, getters) {
    return parseInt(getters.getSessionTimeLeft) > 0
  },

  getSessionTimeLeft(state, getters) {
    let exp = getters.getSessionExpires;
    if (exp < 1) {
      return -1
    }
    return exp - Math.floor(Date.now() / 1000);
  },

  getSessionToken(state) {
    return state.token
  },

  getSessionExpires(state) {
    return state.token_expires
  },

  getUserId(state) {
    return state.user_id
  },

  getRegistrarId(state) {
    return state.registrar_id;
  },

  getTokenSet(state) {
    return state.token_set;
  }

};

const mutations = {

  authenticate(state, data) {
    if (typeof data !== 'string' || data === "") { return }
    let payload = getTokenPayload(data);
    if (payload === null || !(typeof payload === 'object')) { return }

    Vue.set(state, 'token', data);
    localStorage.setItem("epp_token", data);
    api.setSession(data);

    let is_admin = ('roles' in payload && payload.roles.indexOf('admin') >= 0);
    Vue.set(state, 'is_admin', is_admin);
    Vue.set(state, 'logged_in', true);
    Vue.set(state, 'token_expires', payload.exp);
    Vue.set(state, 'user_id', payload.user_id || "");
    Vue.set(state, 'registrar_id', payload.registrar_id || "");
    Vue.set(state, 'token_set', payload.iat)
  },

  anonymize(state) {
    Vue.set(state, 'token', null);
    Vue.set(state, 'token_expires', -1);
    Vue.set(state, 'logged_in', false);
    Vue.set(state, 'is_admin', false);
    Vue.set(state, 'user_id', "");
    Vue.set(state, 'registrar_id', "");
    Vue.set(state, 'token_set', 0);
    localStorage.removeItem('epp_token');
    api.setSession(null);

    // maybe add some logout hook for these so we keep the separation of concern/context?
    localStorage.removeItem('epp_services'); // this is set in the store index, not here
    localStorage.removeItem('epp_extensions'); // this is set in the store index, not here
    localStorage.removeItem('epp_log_enabled'); // this is set in the store index, not here
    localStorage.removeItem('epp_language'); // this is set in the language module, not here
  },

};

const actions = {
  login(ctx, request) {
    api.loginUser(
      request,
      data => {
        ctx.commit('authenticate', data.token);
        ctx.commit('setEppServices', data.epp_services, {root: true});
        ctx.commit('setEppExtensions', data.epp_extensions, {root: true});
        ctx.commit('setEppLogEnabled', data.epp_log_enabled, {root: true});
        router.push({name: 'admin'});
      }
    )
  },

  logout(ctx) {
    ctx.commit('anonymize');
    router.push({name: 'overview'});
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js